import MenuForm from './MenuForm';

const CreateMenu = ({ setPageTitle }) => {
  return <MenuForm setPageTitle={setPageTitle} isEdit={false} />;
};

export default CreateMenu;
